import React, { useEffect, useState } from "react";
import { filterMenuItems, getMenuGroups } from "../menuEngineeringUtils";

export function useMenuGroups(items, scope) {
  const [selection, setSelection] = useState({ scope, page: "", category: "" });
  useEffect(() => {
    setSelection({ scope, page: "", category: "" });
  }, [scope]);
  const pages = getMenuGroups(items, "page");
  const categories = getMenuGroups(items, "category");
  const current = selection.scope === scope ? selection : {};
  const page = pages.some((group) => group.key === current.page) ? current.page : "";
  const category = categories.some((group) => group.key === current.category)
    ? current.category
    : "";

  return {
    items: filterMenuItems(items, page, category),
    isFiltered: Boolean(page || category),
    tabs: {
      pages,
      categories,
      page,
      category,
      total: items.length,
      onSelect: (type, key) =>
        setSelection({ scope, page, category, [type]: key }),
    },
  };
}

export default function MenuGroupTabs({
  pages, categories, page, category, total, onSelect,
}) {
  return (
    <div className="menuGroupTabs">
      {[
        { type: "page", label: "Page", groups: pages, selected: page },
        { type: "category", label: "Category", groups: categories, selected: category },
      ].map(({ type, label, groups, selected }) =>
        groups.length ? (
          <div className="menuGroupTabRow" key={type}>
            <span className="menuGroupTabLabel">{label}</span>
            <div role="group" aria-label={`Filter by ${label.toLowerCase()}`}>
              {[{ key: "", name: "All", count: total }, ...groups].map((group) => (
                <button
                  type="button"
                  key={group.key}
                  className={selected === group.key ? "active" : ""}
                  aria-pressed={selected === group.key}
                  onClick={() => onSelect(type, group.key)}
                >
                  {group.name} <span>{group.count}</span>
                </button>
              ))}
            </div>
          </div>
        ) : null
      )}
    </div>
  );
}
